// Bridge from --site-* CSS tokens to Naive UI GlobalThemeOverrides.
// Naive needs literal color strings — it cannot take `var(...)` — so tokens
// are resolved with getComputedStyle. MUST run after the theme stylesheet is
// applied (onMounted), otherwise every token resolves to '' and Naive falls
// back to its default green.
import type { GlobalThemeOverrides } from 'naive-ui'
import { cssToken } from '@/shared/charts/theme'

export function siteScheme(): 'dark' | 'light' {
    return cssToken('--site-scheme') === 'dark' ? 'dark' : 'light'
}

export function buildNaiveTheme(): GlobalThemeOverrides {
    const accent = cssToken('--site-accent')
    const accentStrong = cssToken('--site-accent-strong')
    const text = cssToken('--site-text')
    const surface = cssToken('--site-surface')
    const border = cssToken('--site-border')
    const radiusMd = cssToken('--site-radius-md')
    const fontBody = cssToken('--site-font-body')

    return {
        common: {
            primaryColor: accent,
            primaryColorHover: accentStrong,
            primaryColorPressed: accentStrong,
            primaryColorSuppl: accent,
            successColor: cssToken('--site-success'),
            warningColor: cssToken('--site-warning'),
            errorColor: cssToken('--site-danger'),
            infoColor: cssToken('--site-info'),
            textColorBase: text,
            bodyColor: cssToken('--site-bg'),
            cardColor: surface,
            modalColor: cssToken('--site-surface-raised'),
            popoverColor: cssToken('--site-surface-raised'),
            borderColor: border,
            borderRadius: radiusMd,
            fontFamily: fontBody,
        },
        Button: {
            textColorPrimary: cssToken('--site-accent-contrast'),
            fontWeight: '600',
        },
        Card: {
            borderRadius: cssToken('--site-radius-lg'),
            color: surface,
        },
        Input: {
            borderRadius: radiusMd,
        },
        Steps: {
            indicatorColorProcess: accent,
        },
    }
}
